'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the user navigation link data
 * @param {GetUserLinksDataParamsType} params The function parameters
 * @param {TunnelType} params.tunnel The request tunnel
 * @param {String} [params.platform] The platform to get the data for. Accepts: 'desktop' or 'mobile',
 * defaults to mobile
 * @param {String} [params.lang] The language to get the data for. Defaults to 'en-gb'
 * @returns {Promise<UserLinksList>} A list of User Links
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var _params$platform, platform, _params$lang, lang, tunnel, endpoint, proxyAgent, data, _data$error, status, title, _data$error$detail, detail, source;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _params$platform = params.platform, platform = _params$platform === undefined ? 'mobile' : _params$platform, _params$lang = params.lang, lang = _params$lang === undefined ? 'en-gb' : _params$lang, tunnel = params.tunnel;
                        endpoint = (0, _getEndpoint2.default)('squiz', '/sportsbook/' + lang + '/site-base/user-menu-api.json');
                        proxyAgent = (0, _config.getProxy)('squiz');
                        _context.next = 5;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 5:
                        data = _context.sent;

                        if (!data.error) {
                            _context.next = 10;
                            break;
                        }

                        tunnel.log.warn('Failed to fetch User Links: ', data.error);

                        _data$error = data.error, status = _data$error.status, title = _data$error.title, _data$error$detail = _data$error.detail, detail = _data$error$detail === undefined ? '' : _data$error$detail, source = _data$error.source;
                        throw new Error('[' + status + '] ' + title + ', ' + detail + '. Source: ' + source);

                    case 10:
                        return _context.abrupt('return', (0, _model2.default)(data, platform));

                    case 11:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getUserLinksData(_x) {
        return _ref.apply(this, arguments);
    }

    return getUserLinksData;
}();
//# sourceMappingURL=userLinks.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/user-links/userLinks.js
// module id = 464
// module chunks = 0